import {Injectable} from "@angular/core";
import {DxAuthenticationStorageStrategy} from "./dx-authentication-storage-strategy";
import {DxUserSession} from "../../../domain/user/dx-user-session";
import {DxObjectMapper} from "../../../../dx-core/services/dx-object-mapper.service";
import {DxEncryptionService} from "../../../../dx-core/services/dx-encryption.service";
import {Observable, of} from "rxjs";
import {fromPromise} from "rxjs/internal-compatibility";


/** Стратегия хранения сессии пользователя в sessionStorage. **/
@Injectable()
export class DxSessionStorageStrategy implements DxAuthenticationStorageStrategy {
  private static DX_USER_SESSION_KEY: string = 'DX_USER_SESSION_KEY';

  constructor(private _mapper: DxObjectMapper,
              private _encryptor: DxEncryptionService) {
  }

  public store(session: DxUserSession): void {
    const jsonData = this._mapper.serialize<DxUserSession>(session, DxUserSession);
    const encryptedStr = this._encryptor.encrypt(jsonData);
    sessionStorage.setItem(DxSessionStorageStrategy.DX_USER_SESSION_KEY, encryptedStr);
  }

  public extract(): Observable<DxUserSession> {
    const encryptedStr = sessionStorage.getItem(DxSessionStorageStrategy.DX_USER_SESSION_KEY);
    let session: DxUserSession = null;
    if(encryptedStr) {
      const decodedJson = this._encryptor.decode(encryptedStr);
      if(decodedJson) {
        session = this._mapper.deserialize<DxUserSession>(decodedJson, DxUserSession);
      }
    }
    return of(session);
  }

  public erase(): void {
    sessionStorage.removeItem(DxSessionStorageStrategy.DX_USER_SESSION_KEY);
  }
}
